import {Directive, ElementRef, EventEmitter, HostListener, Output} from '@angular/core';

@Directive({
  selector: '[appImgLoaded]',
  standalone: false,
})
export class ImgLoadedDirective {

  @Output() readonly imgLoaded = new EventEmitter();

  constructor(private elRef: ElementRef<HTMLImageElement>) {

    if (this.elRef.nativeElement.complete) {
      this.imgLoaded.emit();
    }
  }

  @HostListener('load')
  onLoad(): void {
    this.imgLoaded.emit();
  }

}
